contactInformation.classy.controller({
    name: 'ContactInformationController',
    inject: ['$scope', '$rootScope', 'authServiceFactory', 'InformationService', 'SchoolModelService', 'PermissionModelService', 'SchoolContactsModelService', 'standardCudArrayFactory', 'RestService'],
    init: function() {
        this.$.states = this.InformationService.getStates();
        this.$.provinces = this.InformationService.getProvinces();
        this.$.prefixes = this.InformationService.getSchoolPrefixes();
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.SchoolContactsModelService = this.SchoolContactsModelService;
        this.$rootScope.model = this.SchoolContactsModelService;
        this.$.School_Country = this.SchoolModelService.get()[0].School_Country;
        this.$.items = this.SchoolContactsModelService.get();
        this.$.index = 0;
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.auth = this.authServiceFactory.getAuth();
        this.$.email_array=[];
        for (let i = 0; i < this.$.items.length; i++) {
            if (this.$.items[i].contactEmail === this.$.auth.userEmail) {
                this.setActive(i);
            }
            if (this.$.items[i].deleted === 0) {
                this.$.email_array.push(this.$.items[i].contactEmail);
            }
        }
        this.$.sortableOptions = {
            stop: (e, ui) => {
                this.$.newOrder = [];
                $(".questionrow").each((index) => {
                    this.$.newOrder[index] = $(this).attr("id");
                });
                for (let key in this.$.newOrder) {
                    for (let key2 in this.$.items) {
                        if (this.$.newOrder[key] === this.$.items[key2].recordID) {
                            this.$.items[key2].order = parseInt(key) + 1;
                        }
                    }
                }
                this.$.$apply();
            }
        };
    },
    notificationCheck: function(field, ind)
    {
        var parent = this;
        let flag = 0;
        for (var i = 0; i < this.$.items.length; i++) {
            if (this.$.items[i][field]==3)
                flag += 0;
            else
                flag += 1;
        }
        
        if (flag==0) {
            swal({   
                title: "Warning",   
                text: "You must have someone receiving application notification e-mails. Please make sure someone is receiving them.",   
                type: "warning",   
                confirmButtonColor: "#DD6B55",   
                confirmButtonText: "Okay",   
                closeOnConfirm: true 
            }, function(){   
                parent.$.items[ind][field] = 0;
                parent.$.$apply();
            });
        }
    },
    activeChange: function(field)
    {
        this.$.items[i][field] = this.$.items[i][field].toString();
    },
    isPrimary: function() {
        const regexUserEmail = new RegExp(this.$.auth.userEmail, "i");
        for (let i = 0; i < this.$.items.length; i++) {
            if (this.$.items[i].primary === 1 && this.$.items[i].contactEmail.search(regexUserEmail) > -1) {
                return true;
            }
        }
        return false;
    },
    add: function()
    {
        if (this.$.items[this.$.items.length-1].recordID !== undefined) {
            var index = this.SchoolContactsModelService.new();
            this.$.items = this.SchoolContactsModelService.data;
            this.$.setActive(index);
        }
    },
    setActive: function(index)
    {
        this.$.index = index;
        this.$.items[index].activeTab = true;
        this.$.email_valid=true;
        if ((this.$.index != this.SchoolContactsModelService.data.length-1) && (this.SchoolContactsModelService.data[this.SchoolContactsModelService.data.length-1].recordID === undefined) && (this.SchoolContactsModelService.data[this.SchoolContactsModelService.data.length-1].contactTitle == '')) {
            this.SchoolContactsModelService.data.pop();
            this.$.items = this.SchoolContactsModelService.data;
        }
    },
    makePrimary: function()
    {
        var index = this.$.index;
        this.$.items[index].primary=1;
        this.$.items[index].email_updates=1;
        this.$.items[index].email_market=1;
    },
    removePrimary: function()
    {
        if (this.isPrimary() || this.$.items[index].recordID != this.$.auth.recordID) {
            var index = this.$.index;
            this.$.items[index].primary=0;
            this.$.items[index].email_updates=0;
            this.$.items[index].email_market=0;
        }
    },
    validateEmail: function(email)
    {
        if (this.$.email_array.indexOf(email) != -1 && this.$.email_array.indexOf(email)!=this.$.index) {
            this.$.email_valid = false;
        }
        else {
            this.$.email_valid = true;
        }
    },
    buildArray: function()
    {
        this.$.email_array=[];
        for (var i=0; i < this.$.items.length; i++) 
            this.$.email_array.push(this.$.items[i].contactEmail);
    },
    del: function(index)
    {
        var parent = this;
        swal({
            title: "Are you sure?",
            text: "You will not be able to recover this contact",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it!",
            closeOnConfirm: false
        }, function()
        {
            if (typeof parent.$.items[index].recordID !== 'undefined')
            {
                parent.$.items[index].deleted = 1;
                swal("Deleted!", "The Contact has been deleted.", "success");
                parent.$.SchoolContactsModelService.putMultiple(parent.$.items[index].schoolID, parent.$.items).then(function(response)
                {
                    parent.SchoolContactsModelService.set(response.data);
                    parent.$.items = response.data;
                });
            }
            else
            {
                parent.SchoolContactsModelService.data.pop();
                swal("Deleted!", "The Contact has been deleted.", "success");
            }
        });
    },
    taxNote: function(user)
    {
        if (user.taxNotifications==0) { //DAILY
            user.email_tax_daily = 1;
            user.email_tax_verification = 0;
            user.email_tax_all = 1;
        }
        else if (user.taxNotifications==1) { //SUBMISSION
            user.email_tax_daily = 0;
            user.email_tax_verification = 1;
            user.email_tax_all = 1;
        }
        else if (user.taxNotifications==2) { //BOTH
            user.email_tax_daily = 1;
            user.email_tax_verification = 1;
            user.email_tax_all = 1;
        }
        else if (user.taxNotifications==3) { //NEVER
            user.email_tax_daily = 0;
            user.email_tax_verification = 0;
            user.email_tax_all = 0;
        }
        return user; 
    },
    submit: function(scope, instance, form) {
        let index = this.$.index;
        this.$.validateEmail(this.$.items[index].contactEmail);
        this.$.items[index] = this.$.taxNote(this.$.items[index]);
        if (form.$valid && this.$.email_valid) {
            instance.options.factor  = .3;
            if (typeof this.$.items[index].recordID === "undefined") {
                this.SchoolContactsModelService.post(this.id, this.$.items[index], instance).then((response) => {
                    this.$.items[index].recordID = response.data.id;
                    this.$.sendPasswordLink(this.$.items[index]);
                });
            } else {
                this.SchoolContactsModelService.put(this.id, this.$.items[index], instance).then(() => {
                    this.SchoolContactsModelService.set(this.$.items);
                    if (this.$.items[index].recordID === this.authServiceFactory.getAuth().recordID) {
                        let autharray = this.authServiceFactory.getAuth();
                        autharray.permissions.taxTab = this.$.items[index].taxTab;
                        autharray.permissions.readOnly = this.$.items[index].readOnly;
                        autharray.permissions.faculty = this.$.items[index].faculty;
                        autharray.permissions.confidential = this.$.items[index].confidential;
                        this.authServiceFactory.set(autharray);
                    }
                });
            }
            if (index === 0 && this.$.items[index].primary === 1) {
                let putObject = {
                    contactNameFirst: this.$.items[index].contactNameFirst,
                    contactNameLast: this.$.items[index].contactNameLast,
                    contactPrefix: this.$.items[index].contactPrefix,
                    contactTitle: this.$.items[index].contactTitle,
                    contactAddy1: this.$.items[index].contactAddy1,
                    contactCity: this.$.items[index].contactCity,
                    contactState: this.$.items[index].contactState,
                    contactZip: this.$.items[index].contactZip,
                    contactEmail: this.$.items[index].contactEmail,
                    contact_Work_Phone: this.$.items[index].contact_Work_Phone
                };
                this.SchoolModelService.put(this.authServiceFactory.getAuth().schoolID, putObject, instance);
            }
        } else if (!this.$.email_valid) {
            form.$error.duplicate = true;
            this.$.$apply();
            instance.stop(-1);
        } else {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) {
        this.$.buildArray();
        if (typeof callback !== "undefined") {
            callback();
        }
    },
    sendPasswordLink: function(contact) {
        swal({
            title: "Warning",
            text: "This user will get a password reset email!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Okay",
            closeOnConfirm: false
        }, () => {
            this.authServiceFactory.sendResetEmail({email: contact.contactEmail}).then((data) => {
                if (data.data.error) {
                    if (data.data.error === "invaliduser") {
                        this.$.message = "User does not exist.";
                    } else if (data.data.error === "multipleaccounts") {
                        this.$.message = "Multiple accounts exist for this user, "
                            + "please contact customer service to reset the password.";
                    } else {
                        this.$.message = "Unspecified error, please contact customer service.";
                    }
                    swal("Uhoh!", this.$.message, "error");
                } else if (data.data.success === 1) {
                    switch (data.data.emails) {
                        case 0:
                            this.$.message = "Unspecified error, please contact customer service.";
                            break;
                        case 1:
                            this.$.message = "An email will be sent to the user shortly "
                                + "containing a link to reset their password.";
                            break;
                        case 2:
                            this.$.message = "Two emails will be sent shortly, "
                                + "each containing a link to reset passwords for FAST v3 and v4.";
                            break;
                        default:
                            this.$.message = "Multiple emails will be sent shortly, "
                                + "each containing a link to reset their FAST passwords.";
                    }
                    swal("Success!", this.$.message, "success");
                }
            });
        });
    }
});
